import { useState } from 'react';
import { MailPlus } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const MAX = 50;

export const BulkInvite = ({ ids, emails, authFetch, apiUrl, api, onDone }) => {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const open = async () => {
    if (ids.length > MAX) { setMsg(`Select up to ${MAX} students at a time.`); return; }
    setMsg('');
    const res = await authFetch(`${apiUrl}/api/journey/admin/onboarding/invite/preview`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ emails: emails.length ? emails : ['student@example.com'] }),
    });
    if (!res.ok) { setMsg('Could not load the email preview.'); return; }
    setPreview(await res.json());
  };
  const send = async () => {
    setBusy(true);
    const d = await api('/students/send-invites', { method: 'POST', body: JSON.stringify({ member_ids: ids, confirm: true }) }, true);
    setBusy(false);
    setPreview(null);
    if (d.error) { setMsg(d.error); return; }
    onDone(`Activation invites: ${d.sent} sent${d.failed ? `, ${d.failed} failed` : ''}${d.skipped ? `, ${d.skipped} skipped (already activated or invite still working)` : ''}.`);
  };
  return (
    <>
      <button type="button" onClick={open} className="inline-flex items-center gap-1.5 rounded-full border border-white/30 text-white text-sm font-semibold px-4 py-2 hover:bg-white/10" data-testid="bulk-invite-btn">
        <MailPlus className="w-4 h-4" />Send activation invites
      </button>
      {msg && <span className="text-xs text-red-200" data-testid="bulk-invite-error">{msg}</span>}
      <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
        <DialogContent className="max-w-2xl" data-testid="bulk-invite-dialog">
          <DialogHeader><DialogTitle>Send activation invites to {ids.length} student(s)?</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Students who are already activated or still have a working invite are skipped automatically. Each email has a personal 72-hour link.</p>
          <p className="text-sm"><span className="text-slate-500">Subject:</span> <span className="font-medium" data-testid="bulk-invite-subject">{preview?.subject}</span></p>
          <iframe title="Invite preview" srcDoc={preview?.html} className="w-full h-72 border rounded-lg" data-testid="bulk-invite-preview" />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setPreview(null)} className="rounded-full px-4 py-2 text-sm border" data-testid="bulk-invite-cancel-btn">Cancel</button>
            <button type="button" disabled={busy} onClick={send} className="rounded-full px-5 py-2 text-sm font-semibold bg-[#0b1f4d] text-white disabled:opacity-50" data-testid="bulk-invite-send-btn">
              {busy ? 'Sending…' : `Send ${ids.length} invite(s)`}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
